import React,{useState, useEffect,useRef} from 'react';
import {PaymentElement} from '@stripe/react-stripe-js';
import { setCustomerId } from '../../stores/authStore';
import {CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useDispatch } from 'react-redux';
import './CheckoutForm.css';

const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        name: 'Mahi',
        email: 'ST@elitetechpark.info',
        phone: '777723908777',
        postalCode:'637002'
      });

      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        // setLoading(true);
    
        try {
          const response = await fetch('/server/subscription_portal_function/setup-intent', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          });
    
          const data = await response.json();
    
          if (!response.ok) {
            throw new Error(data.message || 'Error creating customer');
          }
    
          const { client_secret, customer_id } = data.customer;
    
          if (!stripe || !elements) {
            throw new Error('Stripe or Elements not initialized.');
          }
    
          const cardElement = elements.getElement(CardElement);

    
          const { setupIntent, error } = await stripe.confirmCardSetup(client_secret, {
            payment_method: {
              card: cardElement,
              billing_details: {
                name: formData.name,
                email: formData.email,
                phone: formData.phone,
                address: {
                    postal_code: formData.postalCode, 
                  },
              },
            },
          });
    
          if (error) {
            alert('Card setup failed. Please try again.');
            return;
          } 

          dispatch(setCustomerId(customer_id));  // Set the customer_id in Redux

          const cardObj = {
            customer_id: customer_id,
            payment_method: setupIntent?.payment_method,
          };

          const cardResponse = await fetch('/server/subscription_portal_function/save-card-data', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(cardObj),
          });
    
          const cardData = await cardResponse.json();
    
          if (!cardResponse.ok) {
            throw new Error(cardData.message || 'Error saving card details');
          }
    
            } catch (error) {
          console.error('Error:', error);
          alert('An error occurred during the process.');
        } finally {
        //   setLoading(false);
        }
      };
    

  return (
    <form 
        onSubmit={handleSubmit}
        style={{display:"flex",flexDirection:'column',width:'25%',gap:'20px',marginLeft:'100px'}}>
      <CardElement
       options={{
        style: {
          base: {
            // color: '#32325d',
            display:'flex',
            flexDirection:'column',
            fontSize: '16px',
            fontFamily: 'Arial, sans-serif',
            lineHeight: '24px',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#fa755a', 
          },
        },
        // hidePostalCode:false,
      }} 
      />
      <button className='SubmitButton' onClick={handleSubmit}>Submit</button>
    </form>
  );
};

export default CheckoutForm;